import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const StyledIntegrationStatus = styled('div')<{
    theme?: TTheme
    status: 'active' | 'broken' | 'inactive'
}>`
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 6px;
    padding: 4px 10px;
    background-color: ${({ theme, status }) => {
        switch (status) {
            case 'active':
                return theme.colors.semantic.statusActiveBackground
            case 'broken':
                return theme.colors.semantic.statusBrokenBackground
            default:
                return theme.colors.greys[100]
        }
    }};
    color: ${({ theme, status }) => {
        switch (status) {
            case 'active':
                return theme.colors.semantic.statusActiveText
            case 'broken':
                return theme.colors.semantic.statusBrokenText
            default:
                return theme.colors.greys[600]
        }
    }};
    cursor: default;
`
